import { appSettingsHubEn } from './settingsHub.en.js';
import { appOmgevingEn } from './omgevingApp.en.js';
import { appRecurrenceEn } from './recurrenceApp.en.js';
import { appDomeinEn } from './domeinApp.en.js';
import { appMemorizeEn } from './memorizeApp.en.js';
import { appSamenEn } from './samenApp.en.js';
import { appCareEn } from './careApp.en.js';
import { appCultureEn } from './cultureApp.en.js';
import { appProfileEn } from './profileApp.en.js';
import { appRemindersEn } from './remindersApp.en.js';
import { appTodoEn } from './todoApp.en.js';
import { appMissedEn } from './missedApp.en.js';
import { appBillingEn } from './billingApp.en.js';
import { appTimePickerEn } from './timePicker.en.js';
import { appRidesEn } from './ridesApp.en.js';
import { appModulesEn } from './modulesApp.en.js';
import { appHouseholdsEn } from './householdsApp.en.js';
import { appPushEn } from './pushApp.en.js';
import { appActivitiesEn, appChecklistEn } from './golf2App.en.js';
import { appGrowthEn, appSchoolEn } from './groeiSchoolApp.en.js';
import { appBoardConfigEn } from './boardConfigApp.en.js';
import { appAgendaViewsEn, appHomeEn, appWeatherDetailEn } from './homeApp.en.js';
import { appLanguagesEn } from './languagesApp.en.js';
import { appReadAloudEn } from './readAloudApp.en.js';
import { appFeedsEn, appPlacesEn, appTravelEn } from './kaartApp.en.js';
import { appBeheerEn } from './beheerApp.en.js';
import { appWerklijstEn } from './werklijstApp.en.js';
import { appVirtualDeviceEn } from './virtualDevice.en.js';
import { appBoardViewEn } from './boardViewApp.en.js';
import { appDailyEn } from './dailyApp.en.js';
import { appThemesEn } from './themesApp.en.js';
import { appGolf6En } from './golf6App.en.js';
import { appPrivacyRightsEn } from './privacyRights.en.js';
import { appChildConsentEn, appPrivacyStatementEn } from './golf5App.en.js';
// English web-app texts (same shape as app.nl.ts; the type keeps both catalogues in sync).
export const appEn = {
    // Golf 7 (0048): Soera's leren (memorizeApp.en.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.en.ts).
    domein: appDomeinEn,
    memorize: appMemorizeEn,
    // Golf 8 (0049): Samen wonen (samenApp.en.ts).
    samen: appSamenEn,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.en.ts).
    care: appCareEn,
    reminders: appRemindersEn,
    // 0058: to-do's zonder datum of tijd (todoApp.en.ts).
    todo: appTodoEn,
    missed: appMissedEn,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.en.ts).
    billing: appBillingEn,
    profile: appProfileEn,
    culture: appCultureEn,
    timePicker: appTimePickerEn,
    ridesPerDay: appRidesEn,
    modules: appModulesEn,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.en.ts).
    households: appHouseholdsEn,
    push: appPushEn,
    checklist: appChecklistEn,
    activities: appActivitiesEn,
    growth: appGrowthEn,
    school: appSchoolEn,
    languages: appLanguagesEn,
    readAloud: appReadAloudEn,
    places: appPlacesEn,
    travel: appTravelEn,
    feeds: appFeedsEn,
    werklijst: appWerklijstEn,
    beheer: appBeheerEn,
    virtualDevice: appVirtualDeviceEn,
    // Menu Board: het echte bord live bekijken (boardViewApp.en.ts).
    boardView: appBoardViewEn,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.en.ts).
    daily: appDailyEn,
    themes: appThemesEn,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.en.ts).
    home: appHomeEn,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.en.ts).
    boardConfig: appBoardConfigEn,
    agendaViews: appAgendaViewsEn,
    weatherDetail: appWeatherDetailEn,
    golf6: appGolf6En,
    privacyRights: appPrivacyRightsEn,
    // Instellingen als overzicht (settingsHub.en.ts).
    settingsHub: appSettingsHubEn,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.en.ts).
    omgeving: appOmgevingEn,
    // Herhaling in gewone taal (recurrenceApp.en.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceEn,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.en.ts).
    childConsent: appChildConsentEn,
    privacyStatement: appPrivacyStatementEn,
    nav: {
        // 0060: module Notities.
        notes: 'Notes',
        // 0064: module Fotolijst.
        photos: 'Photo frame',
        kompas: 'Healthy weight',
        // 0069: module Geldzaken (privé).
        money: 'Money',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: 'My to-dos',
        today: 'Today',
        board: 'Board',
        agenda: 'Calendar',
        tasks: 'Tasks',
        rewards: 'Rewards',
        approvals: 'Approvals',
        members: 'Family',
        devices: 'Tablets',
        settings: 'Settings',
        security: 'Security',
        household: 'Set up household',
        rides: 'Rides',
        growth: 'Growth',
        school: 'School',
        more: 'More',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'Noticeboard',
        children: 'Children',
        together: 'Together',
        boardHub: 'Board',
        boardView: 'View',
        stars: 'Stars',
        membersTab: 'Members',
        circle: 'Circle',
        forYou: 'For you',
        forYouWaiting: 'To approve: {n}',
        menu: 'Menu',
        logout: 'Log out',
        admin: 'Admin',
        werklijst: 'Work list',
        beheer: 'Customers',
        main: 'Main menu',
        skip: 'Skip to content',
    },
    common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        later: 'Do this later',
        undo: 'Undo',
        retry: 'Try again',
        info: 'More info',
        moreCount: '+{n} more',
        loading: 'Loading…',
        optional: 'optional',
        yes: 'Yes',
        no: 'No',
        none: 'None',
        everyone: 'Everyone',
        minutes: { one: '{count} minute', other: '{count} minutes' },
        minutesShort: '{count} min',
        hoursMinutes: '{h} h {m} min',
        hours: { one: '{count} hour', other: '{count} hours' },
        points: { one: '{count} point', other: '{count} points' },
        by: 'by {name}',
        unknown: 'Unknown',
        errorLoad: 'That did not work just now. Please try again.',
        savedOk: 'Saved',
    },
    offline: 'No connection to the server. We will keep trying.',
    today: {
        goodMorning: 'Good morning',
        goodAfternoon: 'Good afternoon',
        goodEvening: 'Good evening',
        goodNight: 'Good night',
        week: 'Week {week}',
        next: 'Coming up',
        now: 'Happening now',
        startsIn: 'in {time}',
        endsIn: '{time} left',
        nothingNext: 'Nothing else planned today',
        nothingNextBody: 'Time for each other.',
        agenda: 'Today’s calendar',
        addEvent: 'Event',
        addEventLong: 'Add event',
        tasks: 'Today’s tasks',
        tasksAll: 'All tasks',
        noTasks: 'No tasks today',
        approvals: 'Approvals',
        approvalsWaiting: {
            one: '{count} thing is waiting for you',
            other: '{count} things are waiting for you',
        },
        approvalsView: 'View',
        ridesOpen: {
            one: '{count} ride without a driver',
            other: '{count} rides without a driver',
        },
        ridesAll: 'All rides',
        tomorrow: 'Tomorrow',
        tomorrowNothing: 'Nothing planned for tomorrow yet.',
        toAgenda: 'Open calendar',
        goalsTitle: 'Saving up',
    },
    agenda: {
        title: 'Calendar',
        prev: 'Previous',
        next: 'Next',
        today: 'Today',
        newEvent: 'Event',
        filter: 'Show for',
        filterAll: 'Everyone',
        emptyDay: 'Nothing planned on this day yet',
        emptyDayBody: 'Tap + to add something.',
        emptyWeek: 'Nothing planned this week yet',
        emptyRange: 'Nothing planned yet',
        weekTitle: 'Week {week} · {range}',
        trash: 'Bin',
        trashIntro: 'Deleted events are kept for 30 days.',
        trashEmpty: 'The bin is empty.',
        restore: 'Restore',
        restoreUntil: 'Can be restored until {date}',
        restored: '{title} is back in the calendar',
        restoreExpired: 'This event was deleted more than 30 days ago and cannot be restored.',
        export: 'Export calendar',
        exportIntro: 'Download the calendar as an .ics file for your phone or computer.',
        exportHousehold: 'Whole family',
        moved: '{title} moved to {when}',
        moveFailed: 'Moving did not work. The event is back where it was.',
        dragHint: 'Drag an event to move it.',
        allDay: 'All day',
        moreItems: '+{count} more',
    },
    event: {
        when: 'When',
        leave: 'Leave',
        who: 'Who',
        where: 'Where',
        notes: 'Note',
        repeats: 'Repeats',
        rides: 'Drop-off and pick-up',
        dropoff: 'Drop-off',
        pickup: 'Pick-up',
        driverOpen: 'Who drives?',
        driverIs: '{name} drives',
        iDrive: 'I’ll drive',
        chooseDriver: 'Choose a driver',
        nobody: 'Nobody yet',
        driverSaved: '{name} drives',
        driverCleared: 'Driver removed',
        depart: 'Leave at {time}',
        travel: '{count} min travel',
        edit: 'Edit',
        cancelOne: 'Cancel this time',
        cancelledOne: '{title} is off this time',
        cancelled: 'Cancelled',
        restoreOne: 'Go ahead after all',
        restoredOne: '{title} is on again',
        resetOne: 'Back to the usual event',
        resetDone: 'This time matches the series again',
        resetKeptRide: 'This time matches the series again. Who drives stays as you arranged it for this time.',
        resetKeptReminder: 'This time matches the series again. The skipped reminder stays silent this time.',
        resetKeptBoth: 'This time matches the series again. Who drives and the skipped reminder stay as you arranged them for this time.',
        moved: 'Moved',
        changed: 'Changed',
        delete: 'Delete',
        deleted: '{title} deleted',
        deleteTitle: 'Delete {title}?',
        deleteBody: 'You can restore it from the bin for 30 days.',
        duplicate: 'Duplicate',
        duplicated: 'Copy created',
        history: 'What changed?',
        historyEmpty: 'No changes yet.',
        historyItem: '{who} · {when}',
        conflict: 'Overlaps with something else',
        conflictWith: {
            one: '{names} also has {title}',
            other: '{names} also have {title}',
        },
        conflictDrive: '{name} drives at {time} but still has {title}',
        lastChanged: 'Last changed by {name}',
        notFound: 'This event no longer exists.',
        action: {
            create: 'created',
            update: 'changed',
            delete: 'deleted',
            restore: 'restored',
            split: 'changed from here on',
            cancel: 'cancelled',
            uncancel: 'is on again',
            move: 'moved',
            override: 'changed this time',
            override_clear: 'back to the series',
            role: 'driver changed',
        },
    },
    editor: {
        newTitle: 'New event',
        editTitle: 'Edit event',
        title: 'What',
        titlePlaceholder: 'For example Swimming lesson',
        titleHint: 'Short and clear, for example Swimming lesson',
        templates: 'Quick pick',
        picto: 'Picture',
        pictoChoose: 'Choose a picture',
        pictoChange: 'Other picture',
        who: 'For whom',
        everyone: 'Everyone',
        date: 'Date',
        allDay: 'All day',
        start: 'From',
        end: 'To',
        duration: 'Duration',
        endDate: 'Until',
        endBeforeStart: 'The end time is before the start time.',
        repeat: 'Repeat',
        repeatNone: 'Never',
        repeatDaily: 'Every day',
        repeatWeekly: 'Every week',
        repeatBiweekly: 'Every other week',
        repeatMonthly: 'Every month',
        repeatYearly: 'Every year',
        onDays: 'On which days',
        monthlyHow: 'Which day of the month',
        monthlyDay: 'On day {day}',
        monthlyLast: 'On the last day',
        monthlyNth: 'On the {ordinal} {weekday}',
        ordinal: {
            '1': 'first',
            '2': 'second',
            '3': 'third',
            '4': 'fourth',
            '-1': 'last',
        },
        parity: 'Which weeks',
        parityAll: 'All weeks',
        parityEven: 'Even weeks',
        parityOdd: 'Odd weeks',
        ends: 'Ends',
        endsNever: 'Never',
        endsCount: 'After a number of times',
        endsUntil: 'On a date',
        count: 'Number of times',
        until: 'Until',
        nextDates: 'Next times',
        rides: 'Drop-off and pick-up',
        ridesHint: 'Who drops off and who picks up? Choose "Not known yet" if you are not sure.',
        dropoff: 'Drop-off',
        pickup: 'Pick-up',
        roleNone: 'Not needed',
        roleOpen: 'Still open (who drives?)',
        travel: 'Travel time',
        travelNone: 'None',
        travelOwn: 'Own time…',
        travelOwnLabel: 'Travel time in minutes',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'Travel time back',
        travelBackHint: 'The same travel time after the appointment too, for the way home.',
        travelAuto: 'Automatic (from the place)',
        travelAutoWith: 'Automatic ({minutes} min)',
        departureAlert: 'Time-to-leave reminder',
        departureAlertHint: 'The board shows when it is time to leave.',
        departureNone: 'No reminder',
        departureBefore: '{count} min before',
        location: 'Where',
        locationPlaceholder: 'For example the swimming pool',
        notes: 'Note',
        notesPlaceholder: 'Bring swim bag and towel',
        category: 'Type',
        more: 'More options: rides, place, note',
        less: 'Fewer options',
        fullScreen: 'Full screen',
        smallScreen: 'Make smaller',
        discardTitle: 'Discard changes?',
        discardBody: 'What you filled in will be gone.',
        discardKeep: 'Keep editing',
        discardConfirm: 'Discard',
        create: 'Save event',
        save: 'Save',
        created: '{title} is in the calendar',
        saved: 'Event saved',
        conflictNotice: {
            one: '{names} also has {title} ({time}).',
            other: '{names} also have {title} ({time}).',
        },
        orphansTitle: 'There are separate changes',
        orphansBody: 'Some times were changed separately and would disappear. What should we do?',
        orphansKeep: 'Keep them as separate events',
        orphansDelete: 'Discard them',
        onlyThisNoRepeat: 'Change a repeat for this and following times or for the whole series.',
        titleRequired: 'Say what it is.',
        memberRequired: 'Choose who it is for.',
        categories: {
            sport: 'Sport',
            school: 'School',
            medisch: 'Doctor and dentist',
            sociaal: 'Appointment',
            werk: 'Work',
            verjaardag: 'Birthday',
            overig: 'Other',
        },
    },
    scope: {
        thisHint: 'Only {date}',
        followingHint: 'From {date}',
        allHint: 'Every time, including earlier ones',
        deleteFollowing: 'Delete this and following',
        confirm: 'Continue',
    },
    rides: {
        title: 'Rides',
        subtitle: 'Who drops off and picks up whom, this coming week.',
        open: 'No driver yet',
        arranged: 'Arranged',
        empty: 'All rides are arranged.',
        emptyBody: 'Nobody needs to look for a lift.',
        none: 'No rides this week.',
        noneBody: 'Set who drops off or picks up on an event and it will show here.',
        iDrive: 'I’ll drive',
        choose: 'Choose',
        dropoff: 'Drop-off',
        pickup: 'Pick-up',
        notLinked: 'Your login is not linked to a family member yet. Choose who drives below.',
    },
    tasks: {
        title: 'Tasks',
        viewToday: 'Today',
        viewWeek: 'Week',
        viewAll: 'All',
        add: 'Task',
        addLong: 'Add task',
        newTitle: 'New task',
        editTitle: 'Edit task',
        library: 'Chore ideas',
        libraryIntro: 'Pick a chore and who it is for. Points match the age.',
        libraryAdd: 'Add',
        libraryFor: 'For whom',
        what: 'What',
        titlePlaceholder: 'For example Set the table',
        who: 'For whom',
        mode: 'How',
        modeEach: 'Each on their own',
        modeEachHint: 'Everyone does it and earns their own points.',
        modeTogether: 'Together',
        modeTogetherHint: 'You do it together; one tick for everyone.',
        modeFirst: 'First one wins',
        modeFirstHint: 'Whoever does it first gets the points.',
        repeat: 'How often',
        repeatOnce: 'Once',
        repeatDaily: 'Every day',
        repeatWeekdays: 'On weekdays',
        repeatWeekly: 'Every week',
        repeatMonthly: 'Every month',
        onDays: 'On which days',
        monthDay: 'On day',
        monthLast: 'Last day',
        startDate: 'From',
        date: 'On',
        dueDate: 'At the latest',
        timeOfDay: 'Time of day',
        tod: {
            any: 'All day',
            morning: 'Morning',
            afternoon: 'Afternoon',
            evening: 'Evening',
        },
        dueTime: 'Done by',
        points: 'Points',
        pointsHint: 'How many stars is it worth? 0 is fine too.',
        approval: 'Needs approval',
        approvalHint: 'A parent approves the task before the points count.',
        approvalHintNoPoints: 'A parent checks the task before it counts as done.',
        description: 'Explanation',
        create: 'Save task',
        created: '{title} is ready',
        saved: 'Task saved',
        deleteTitle: 'Delete {title}?',
        deleted: '{title} deleted',
        duplicateTitle: 'This task already exists',
        duplicateBody: 'There is already a task {title} for {names}. Add another one anyway?',
        addAnyway: 'Add anyway',
        emptyTitle: 'No tasks yet',
        emptyBody: 'Start with something small, like brushing teeth.',
        emptyToday: 'No tasks today',
        emptyTodayBody: 'Tasks for today appear here.',
        progress: '{done} of {total} done',
        completeFor: 'Tick off for {name}',
        completed: '{title} ticked off',
        revert: 'Set back to open',
        reverted: '{title} is open again',
        skip: 'Skip',
        skipped: '{title} skipped',
        unskip: 'Do it after all',
        state: {
            open: 'Open',
            done: 'Done',
            pending: 'Waiting for approval',
            rejected: 'One more time',
            skipped: 'Skipped',
            missed: 'Missed',
        },
        late: 'Left over from yesterday',
        next: 'Next time: {date}',
        noNext: 'No next time',
        together: 'Together',
        negativeTitle: 'Points go below zero',
        negativeBody: '{names} already spent these points. The balance will become negative.',
        negativeConfirm: 'Set back anyway',
        perMember: 'Points per child',
    },
    rewards: {
        title: 'Rewards',
        savings: 'Piggy banks',
        available: '{count} to spend',
        reserved: '{count} reserved',
        goal: 'Saving for',
        noGoal: 'No savings goal yet',
        setGoal: 'Savings goal',
        goalNone: 'No goal',
        chooseGoal: 'Choose a savings goal',
        ledger: {
            task_credit: 'Task',
            task_reversal: 'Task set back',
            reward_debit: 'Reward',
            reward_refund: 'Reward refunded',
            manual_adjustment: 'Adjusted by a parent',
            bonus: 'Bonus',
            cleaning_credit: 'Cleaning',
            cleaning_reversal: 'Cleaning set back',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'Well learned',
            learning_reversal: 'Well learned undone',
        },
        goalMissing: {
            one: '{count} point to go',
            other: '{count} points to go',
        },
        goalReached: 'Saved enough',
        goalSaved: 'Savings goal saved',
        catalogue: 'To save up for',
        add: 'Reward',
        addLong: 'Add reward',
        newTitle: 'New reward',
        editTitle: 'Edit reward',
        name: 'What',
        namePlaceholder: 'For example Get an ice cream together',
        cost: 'How many stars?',
        costHint: 'Number of points (1 to 9999).',
        costInvalid: 'Choose a number from 1 to 9999.',
        forWhom: 'For whom',
        forAll: 'Everyone with points',
        limit: 'How often',
        limitNone: 'As often as you like',
        limitDay: '{count}× per day',
        limitWeek: '{count}× per week',
        limitMonth: '{count}× per month',
        stock: 'Stock',
        stockNone: 'Unlimited',
        stockLeft: '{count} left',
        created: '{name} added',
        saved: 'Reward saved',
        archive: 'Remove',
        archiveTitle: 'Remove {name}?',
        archiveBody: 'Children will no longer see it. Earlier requests are kept.',
        archived: '{name} removed',
        requests: 'Requests',
        requestsEmpty: 'No open requests.',
        give: 'Give',
        given: '{name} given to {member}',
        decline: 'Decline',
        declined: 'Request declined; the points are back',
        adjust: 'Adjust points',
        adjustTitle: 'Adjust points for {name}',
        adjustAmount: 'How many',
        adjustAmountHint: 'Use a minus to subtract, for example -5.',
        adjustReason: 'Why',
        adjustReasonPlaceholder: 'For example Extra help in the garden',
        adjustInvalid: 'Choose a number between -999 and 999 (not 0).',
        adjustReasonRequired: 'Write briefly why.',
        adjusted: '{name} now has {count}',
        negativeTitle: 'Balance goes negative',
        negativeBody: 'This takes {name} below zero. Are you sure?',
        negativeConfirm: 'Yes, adjust',
        history: 'Recent points',
        historyEmpty: 'No points earned yet.',
        pointsOff: 'Points are off',
        export: 'Export (CSV)',
    },
    approvals: {
        title: 'Approvals',
        open: 'Open',
        handled: 'Handled',
        approve: 'Approve',
        approved: '{title} approved',
        reject: 'Decline',
        rejectTitle: 'Decline {title}?',
        rejectNote: 'What still needs doing?',
        rejectNotePlaceholder: 'For example The plates still need to go on the table',
        rejected: '{title} goes back to {name}',
        asks: '{name} asks for',
        doneAt: 'done at {time}',
        doneAgo: 'done {ago}',
        give: 'Give',
        decline: 'Decline',
        notices: 'Good to know',
        emptyTitle: 'All done',
        emptyBody: 'Nothing to approve.',
        handledEmpty: 'What you handled will show up here.',
        state: {
            fulfilled: 'Given',
            declined: 'Declined',
            cancelled: 'Withdrawn',
            expired: 'Expired',
            pending: 'Open',
        },
        together: 'together with {names}',
    },
    members: {
        title: 'Family',
        intro: 'Everyone on the board. You will see their colour and face everywhere.',
        add: 'Family member',
        addLong: 'Add family member',
        newTitle: 'New family member',
        editTitle: 'Edit {name}',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'Use the arrows to set the order. It applies everywhere: in the app and on the board.',
        moveUp: 'Move {name} earlier',
        moveDown: 'Move {name} later',
        orderNow: '{name} is now number {position} of {count}.',
        orderStale: 'Something changed in the family in the meantime. The list has been reloaded.',
        name: 'Name',
        namePlaceholder: 'For example Sam',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'Initials',
        initialsHint: 'One to three letters. They appear after the event in the calendar, for example Football · A.',
        initialsInvalid: 'Enter one to three letters.',
        kind: 'Who is it',
        kindAdult: 'Parent',
        kindChild: 'Child',
        kindHelper: 'Babysitter or helper',
        age: 'Age',
        ageNone: 'Not sure',
        ageBands: {
            '0-5': 'under 6',
            '6-9': '6–9 years',
            '10-12': '10–12 years',
            '13-15': '13–15 years',
            '16+': '16 or older',
        },
        face: 'Face',
        faceNone: 'First letter',
        preview: 'This is how it looks',
        saved: '{name} saved',
        created: '{name} is now part of the family',
        you: 'You',
        points: 'Saves points',
        inviteTitle: 'Invite your partner',
        inviteBody: 'Planning together is easier. Add your partner, then invite them by email.',
    },
    devices: {
        title: 'Tablets',
        intro: 'The tablets that run the family board.',
        add: 'Pair a tablet',
        online: 'Online',
        seen: 'Last seen {ago}',
        never: 'Never seen',
        version: 'Version {version}',
        room: 'Room',
        rename: 'Edit',
        renameTitle: 'Edit tablet',
        layout: 'Layout',
        layoutAuto: 'Automatic',
        layoutAutoHint: 'Adapts to the screen by itself, also when you rotate the tablet: compact on a small screen, wide on a big screen in landscape, large otherwise.',
        layoutLarge: 'Large',
        layoutLargeHint: 'The whole board side by side, like the iPad in the living room.',
        layoutCompact: 'Compact',
        layoutCompactHint: 'Less side by side and everything bigger, readable from 2 metres. For a small tablet or an iPad mini.',
        layoutShown: 'Layout: {layout}',
        layoutWide: 'Wide',
        layoutWideHint: 'Calendar, tasks and a Today column side by side. For a tablet of 10 inches or more hung in landscape.',
        revoke: 'Unpair',
        revokeTitle: 'Unpair this tablet?',
        revokeBody: '{name} will show a pairing code again. You can pair it again later.',
        revoked: '{name} unpaired',
        saved: 'Tablet saved',
        statusRevoked: 'Unpaired',
        statusSuspect: 'Check',
        emptyTitle: 'Pair the tablet',
        emptyBody: 'Open the family board on the tablet and enter the code here.',
    },
    settings: {
        title: 'Settings',
        household: 'Household',
        householdName: 'Name',
        timezone: 'Time zone',
        wizard: 'Set up household',
        security: 'Security',
        securityBody: 'Trusted networks, browsers and sessions.',
        export: 'Export calendar',
        exportBody: 'Download the calendar as an .ics file, for the whole family or per person.',
        exportAll: 'Whole family',
        data: 'Download data',
        dataBody: 'A copy of your data as a file (JSON), including the choices in What fits our family. You confirm with your password first.',
        dataMine: 'My data',
        dataAll: 'Whole family',
        dataStarted: 'The file is in your downloads.',
        about: 'About',
        version: 'Version {version}',
        open: 'Open',
    },
    wizard: {
        step: 'Step {n} of {total}',
        step1Title: 'Welcome home',
        step1Body: 'See the week together, without the hassle. Let’s start with your family.',
        householdName: 'Name of your household',
        householdPlaceholder: 'The Smith family',
        yourName: 'Your name on the board',
        yourNameHint: 'For example Dad or Sanne',
        step2Title: 'Who is in the family?',
        step2Body: 'Give everyone a colour. A child can also pick an animal.',
        addMember: 'Add someone else',
        memberAdded: '{name} added',
        step3Title: 'First tasks',
        step3Body: 'Tap a few regular chores. You can change everything later.',
        step3For: 'For the children',
        step3Added: {
            one: '{count} task added',
            other: '{count} tasks added',
        },
        step3NoKids: 'Add a child first to give out tasks.',
        step4Title: 'Pair the tablet',
        step4Body: 'Open the family board on the living-room tablet and enter the code.',
        pairNow: 'Pair a tablet',
        finish: 'Done',
        done: 'Your household is ready',
    },
    notFoundTitle: 'This page does not exist',
    notFoundBody: 'The link may be old. Go back to today.',
    toToday: 'Go to Today',
    crashTitle: 'Oops, something went wrong',
    crashBody: 'Please try again. Still not working? Reload the page.',
    reload: 'Reload',
};
//# sourceMappingURL=app.en.js.map